if (!window.Eurus.loadedScript.has("product-tabs.js")) {
  window.Eurus.loadedScript.add("product-tabs.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductTabs", (initialOpen = 0) => ({
        open: initialOpen, 
        openMobile: false, 
        tabActive: '',
        setTabActive() {
          const tabActive = this.$el.dataset.tabtitle;
          this.tabActive = tabActive;
        }
      }));
    });
  });
}
